<template>
    <button class="favorite-btn btn button-transparent-red btn--100" :class="{'favorite-btn--active':inFavorite}" @click.prevent="addToFavorite"@mouseout="mouseOut" @mouseover="mouseOver">
        <span  v-if="inFavorite" >{{text}}</span>
        <span v-else>Добавить в избранное</span>
    </button>
</template>
<script>
    import { bus } from './bus.js'
    export default {
        props:{
          id:Number,
          type:String
        },
        data() {
            return {
                inFavorite:false,
                text:'В избранном',
            }
        },
        methods:{
          mouseOut() {
            if(this.inFavorite) {
              this.text = 'В избранном';
            }
          },
          mouseOver() {
            if(this.inFavorite) {
              this.text = 'Удалить из избранного';
            }
          },
            addToFavorite() {
            console.log(this.type)
                axios.post('/api/favorite/action',{id:this.id, status:this.inFavorite, type:this.type})
                    .then((response) => {
                        this.inFavorite = response.data;
                        bus.$emit('add-favorite',this.inFavorite);
                    })
            },
            getFavoriteStatus() {
                axios.get('/api/favorite/status', {
                  params: {id:this.id, type:this.type}
                })
                    .then((response) => {
                        this.inFavorite = response.data;
                    })
            }
        },
        mounted() {
            this.getFavoriteStatus();
        }
    }
</script>
